import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { setUserVideoPlayerStatus } from '../../../../common/actions/user/preference'
import { IRootState } from '../../../../common/reducers'

import VideoHiveItemCard from './videoHiveItemCard'

interface IStateProps {
  muted: boolean
}

interface IDispatchProps {
  muteVideo: () => any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { user: { preferences } } = state

  return {
    muted: preferences.searchVideoMuted
  }
}

const mapDispatchToProps = (dispatch: Dispatch<IRootState>) => {
  return {
    muteVideo: () => dispatch(setUserVideoPlayerStatus(true))
  }
}

const VideoHiveItemCardContainer = connect<IStateProps, IDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(VideoHiveItemCard)

export default VideoHiveItemCardContainer
